<template>
  <div class="">
    <a-modal :title="title" v-model="modalShow" width="950px" @cancel="close" :footer="null" destroyOnClose>
      <a-form-model v-if="dialogType != 'detail'&&!details" class="common-form-inline" :rules="ruleForm" ref="ruleForm" :model="pageData"
                    :label-col="{ span: 4 }" :wrapper-col="{ span: 13 }">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item label="凭证类型" prop="documentType">
              <a-radio-group v-model="pageData.documentType">
                <a-radio v-for="item in VoucherDocumentTypeList" :key="item.dctVal" :value="item.dctVal">{{
                                item.dctValNm }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="凭证编号" prop="voucherCode">
              <a-input v-model="pageData.voucherCode" @blur="getTableList" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="附件上传" prop="fileId">
              <div style="position:relative">
                <fileUpload accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.pdf,.PDF" ref="fileUpload" :paramObj="uploadParam" @uploadOkCopy="uploadOk"
                            @handleFileRemoveCopy="removeOk" :removeaction="true" name="file" :multiple="true" :limit="99" />
                <div class="text-color-orange img-tip">注：附件支持图片及pdf格式，且大小不可超过30M</div>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div v-if="dialogType != 'detail'&&!details" class="spaceCenter" style="margin-bottom:16px;">
        <button-load @clickHandle="save" type="primary" lable="导入列表" />
      </div>
      <div class="table-common common">
        <a-table :loading="tableLoading" size="middle" :columns="columns" :row-key="record => record.id" :data-source="tableData" :pagination="false"
                 bordered :locale="{ emptyText: '暂无数据' }">
          <template slot="gldId" slot-scope="text">
            <span @click='toGldDetail'>{{ text}}</span> </template>
          <template slot="name" slot-scope="text,record">
            <a style="width:180px"  type="link" @click="lookFile(record)">{{text || record.file.fileNm}}</a>
          </template>
          <template slot="documentType" slot-scope="text">{{ text |
                    dictFilter(VoucherDocumentTypeList) }}</template>
          <template slot="createTime" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
          <template slot="oper" slot-scope="text,record,index">
            <a-button v-if="(record.gldId == null || !record.gldId)&&!details" type="link" @click="handleSort(record, 'up')">上移</a-button>
            <a-button v-if="(record.gldId == null || !record.gldId)&&!details" type="link" @click="handleSort(record, 'down')">下移</a-button>
            <span class="text-color-red pointer" v-if="(dialogType != 'detail' || record.gldId == null || !record.gldId)&&!details"
                  @click="delFun(record, index)">撤销</span>
            <a @click="downloadFile(record.file)">下载附件</a>
          </template>

        </a-table>
      </div>
    </a-modal>
    <!-- 图片预览 -->
    <imgView ref="imgView" :src.sync="viewSrc" />
    <a-modal v-model="pdfVisible" title="PDF 预览" width="80%" :footer="null">
      <div ref="pdfContainer" style="height: 70vh; overflow: auto;"></div>
    </a-modal>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import { addBatchVoucher, addVoucher, deleteVoucherById, getVoucherList, updateVoucherSort } from '@/api/payable.js';
import { fileSaveAPI } from '@/api/file.js';
import { mapActions } from 'vuex';
export default {
  props: {
    info: {
      type: [Object],
      default: function () {
        return {};
      }
    },
    details: {
      type: [Boolean],
      default: function () {
        return false;
      }
    }
  },
  components: {},
  name: 'invoice-info-dialog',
  data() {
    return {
      titleMap: {
        add: '相关凭证-上传',
        edit: '相关凭证-编辑',
        detail: '相关凭证-查看'
      },
      title: '相关凭证-上传',
      dialogType: 'add',
      invData: {},
      invDataList: [],
      readonly: false,
      modalShow: false,
      tableLoading: false,
      tableData: [],
      uploadParam: {
        app: 'portal-pc',
        module: 'payable',
        user: this.$store.getters['home/getUserHeader'].realname,
        tblBlId: this.utils.guid(32, 16),
        mdlId: 'payable'
      },
      VoucherDocumentTypeList: [],
      pageData: {
        file: null,
        fileId: undefined,
        documentType: '1',
        voucherCode: undefined,
        fileList: []
      },
      voucherCodeValidate: false,
      ruleForm: {
        // documentType:[
        //     { required: true, message: '凭证类型不能为空', trigger: 'change' }
        // ],
        // voucherCode:[
        //     {   required: true, trigger: 'blur',
        //         validator:(rule,value,cbfn) => {
        //             if (!value) {
        //                 cbfn('凭证编号不能为空');
        //             }
        //             else if(this.voucherCodeValidate){
        //                 cbfn('此凭证编号已关联祺信，不可再次使用');
        //             }
        //             else{
        //                 cbfn();
        //             }
        //         } }
        // ],
        fileId: [
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, cbfn) => {
              if (this.pageData.fileList == []) {
                cbfn('请上传附件');
              } else {
                cbfn();
              }
            }
          }
        ]
      },
      columns: [
        {
          title: '序号', // 列标题
          key: 'index', // 列的 key
          width: 80, // 列宽度（可选）
          align: 'center', // 对齐方式（可选）
          customRender: (text, record, index) => {
            // 返回当前行的序号（从1开始）
            return index + 1;
          }
          // 或者使用 scopedSlots（Vue 2.x 语法）
          // scopedSlots: { customRender: 'index' }
        },
        {
          title: '祺信编号',
          dataIndex: 'gldId',
          scopedSlots: { customRender: 'gldId' }
        },
        {
          title: '凭证名称',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          width: 180
        },
        {
          title: '凭证类型',
          dataIndex: 'documentType',
          scopedSlots: { customRender: 'documentType' }
        },
        {
          title: '凭证编号',
          dataIndex: 'voucherCode'
        },
        {
          title: '上传人',
          dataIndex: 'createUser'
        },
        {
          title: '上传日期',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '操作',
          dataIndex: 'oper',
          scopedSlots: { customRender: 'oper' },
          width: 240,
        }
      ],
      fileReadonly: false,
      pdfVisible: false,
      viewSrc: '' //图片预览地址
    };
  },
  computed: {
    ...mapGetters({
      userObj: 'home/getUserObj'
    })
    // showList() {
    //   if (!this.pageData.file) {
    //     return [];
    //   } else {
    //     return [this.pageData.file];
    //   }
    // }
  },
  created() {
    this.getDicAsync('VoucherDocumentType').then((res) => {
      this.VoucherDocumentTypeList = res;
    });
  },
  methods: {
    ...mapActions({
      getDicAsync: 'app/getDicAsync'
    }),
    open({ invData, invDataList, dialogType, voucherList }) {
      /**
       * @params{dialogType} add\edit\detail
       */
      console.log('%c Line:197 🍻 invDataList', 'color:#3f7cff', invDataList);
      this.dialogType = dialogType || 'add';
      this.title = this.titleMap[dialogType];
      this.invData = this.utils.deepClone(invData || {});
      this.invDataList = this.utils.deepClone(invDataList || {});

      this.readonly = dialogType == 'add' ? false : true;
      this.modalShow = true;
      this.getInfo();
      if (voucherList) {
        this.tableData = voucherList.map((item, index) => {
          return { ...item, index, name: item.file.fileNm };
        });

        return;
      } else if (dialogType != 'add') {
        this.getInfo();
      }
      console.log(invDataList);
      console.log(this.tableData);
    },

    //排序
    updateSort(data) {
      updateVoucherSort({ list: data }).then((res) => {
        this.getInfo();
      });
    },
    handleSort(data, text) {
      let sort = null;
      let sort1 = null;
      let id = null;
      if (text == 'up') {
        if (this.tableData.length < 2) {
          return;
        }
        sort = Number(data.sort) + 1;
        if (sort > this.tableData.length) {
          return;
        }
        sort1 = data.sort;
        id = this.tableData[data.index - 1].id;
      } else {
        if (this.tableData.length < 2) {
          return;
        }
        sort = Number(data.sort) - 1;
        if (sort < 1) {
          return;
        }
        sort1 = data.sort;
        id = this.tableData[data.index + 1].id;
        if(this.tableData[data.index + 1].gldId){
          console.log("%c Line:282 🥑 this.tableData[data.index + 1].gldId", "color:#6ec1c2", this.tableData[data.index + 1].gldId);
          return
        }
      }
      let params = [
        { id: data.id, sort: sort },
        { id: id, sort: sort1 }
      ];
      console.log(params);

      this.updateSort(JSON.stringify(params));
    },
    getInfo() {
      this.tableLoading = true;
      if (this.invData.cyCode) {
        getVoucherList({
          cyCode: this.invData.cyCode
        }).then((res) => {
          this.tableData = res.data || [];
          this.tableLoading = false;
          this.tableData = res.data.map((item, index) => ({ ...item, index, name: item.file.fileNm })).sort((a, b) => Number(b.sort) - Number(a.sort));
        });
      } else {
        this.tableLoading = false;
      }
    },
    getTableList() {
      this.voucherCodeValidate = false;
      if (!this.pageData.voucherCode) return;
      let inItem = this.tableData.find((i) => i.voucherCode == this.pageData.voucherCode);
      if (inItem) {
        return;
      }
      this.tableLoading = true;
      getVoucherList({
        voucherCode: this.pageData.voucherCode,
        sellerOrgCode: this.invData.sellrOrgCode,
        buyerOrgCode: this.invData.buryOrgCode
      })
        .then((res) => {
          this.tableLoading = false;
          let item = res.data[0];
          if (item) {
            if (item.payableAmount != item.canEstbGldBal) {
              // 存在开立祺信在途业务
              this.voucherCodeValidate = true;
              this.$refs.ruleForm && this.$refs.ruleForm.validateField('voucherCode');
              return;
            }
            let params = {
              documentType: item.documentType,
              fileId: item.fileId,
              voucherCode: item.voucherCode,
              sellerOrgCode: this.invData.sellrOrgCode,
              buyerOrgCode: this.invData.buryOrgCode,
              cyCode: this.invData.cyCode
            };
            addVoucher(params).then((res) => {
              this.getInfo();
              this.$emit('save');
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    close() {
      this.pageData = {
        file: null,
        fileId: undefined,
        documentType: '1',
        voucherCode: undefined,
        fileList : []
      };
      this.tableData = [];
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      this.modalShow = false;
    },
    // 删除文件
    removeOk(param) {
      console.log("%c Line:347 🍐 param", "color:#ffdd4d", param);
    
       this.pageData.fileList.forEach((el, index) => {
          if (param.fileRte == el.fileRte) {
            this.pageData.fileList.splice(index, 1);
          }
        });
      console.log('%c Line:351 🍤 this.pageData.fileList', 'color:#ea7e5c', this.pageData.fileList);

      // this.pageData.file = null;
      // this.pageData.fileId = undefined;
    },
    fileSave(data) {
      // const param = {
      //     fileNm: data.name,
      //     fileSize: data.size,
      //     fileRte: data.fileRte,
      //     fileExpdNm: data.fileExpdNm,
      //     tblBlId: this.uploadParam.tblBlId,
      //     mdlId: 'payable',
      // }
     const param = {
          fileNm: data.name,
          fileSize: data.size,
          fileRte: data.fileRte,
          fileExpdNm: data.fileExpdNm,
          tblBlId: this.uploadParam.tblBlId,
          mdlId: 'payable'
        };
        console.log(param, 'ppp');
        fileSaveAPI(param)
          .then((res) => {
            this.uploading = false;
              console.log("%c Line:381 🍎 this.pageData.fileList", "color:#33a5ff", this.pageData.fileList);

            this.pageData.fileList.push({
              ...param,
              fileId: res.data.fileId
            });
            // this.pageData.fileId = res.data.fileId;
            // this.pageData.file = data;
            this.$refs.ruleForm && this.$refs.ruleForm.validateField('fileId');
          })
          .catch((err) => {
            this.uploading = false;
            console.log(err);
          });
    },
    uploadOk(fileObj) {
      console.log("%c Line:395 🍻 fileObj", "color:#f5ce50", fileObj);
      

      this.fileSave(fileObj);
    },
    initData() {
      this.pageData = {
        file: null,
        fileId: undefined,
        documentType: '1',
        voucherCode: undefined,
        fileList:[]
      };
      this.$refs.fileUpload.setFileList();
    },
    delFun(record, index) {
      const self = this;
      this.$confirm({
        title: '撤销',
        content: '您正在进行撤销操作，是否确认？',
        onOk() {
          deleteVoucherById({
            id: record.id
          }).then((res) => {
            self.$message.success('撤销成功');
            self.tableData.splice(index, 1);
            self.$emit('save');
          });
        },
        onCancel() {}
      });
    },
    save(btn) {
      let inItem = this.tableData.find((i) => i.voucherCode == this.pageData.voucherCode);
      if (inItem) {
        this.$message.warn('凭证信息已在列表中，不可重复提交');
        btn && btn.closeLoad();
        return;
      }
      let current_index_max = 1;
      if(this.tableData.length != 0){
        current_index_max=  Number(this.tableData[0].sort)  + 1
      }
        console.log("%c Line:454 🍒 current_index_max", "color:#7f2b82", current_index_max);
      
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let listStr = [];
          console.log('%c Line:201 🥪 this.invDataList', 'color:#f5ce50', this.invDataList);
          this.invDataList.forEach((item, index) => {
            this.pageData.fileList.forEach((el, index) => {
                 listStr.push({
              sellerOrgCode: item.sellrOrgCode,
              buyerOrgCode: item.buryOrgCode,
              cyCode: item.cyCode,
              name: el.fileNm,
              fileId: el.fileId,
              //计算排序值
              sort: current_index_max
            });
            });
           
          });
          addBatchVoucher({ listStr: JSON.stringify(listStr) })
            .then((res) => {
              this.$message.success('操作成功');
              btn && btn.closeLoad();
              this.initData();
              this.getInfo();
              this.$emit('save');
            })
            .catch((err) => {
              btn && btn.closeLoad();
              console.log(err);
            });
        } else {
          btn && btn.closeLoad();
        }
      });
    },
    downloadFile(item) {
      const DOWNLOAD_PREFIX = '/gb-bigtree-file/download/fileDownload/install';
      window.open(`${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`, '_blank');
    },
    toGldDetail(row) {
      this.MENUAPI.goToOneTab({
        path: 'bill-payment/payment/detail/' + way + '/' + data.gldId + '/' + 3,
        query: {
          fromPath: 'bill-payment/payment'
        }
      });
    },
    async lookFile(row) {
      if (row.file && row.file.fileExpdNm.indexOf('pdf') > -1) {
        const pdfjsLib = await import('pdfjs-dist/build/pdf');
        const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');

        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
        console.log('%c Line:425 🍷 this.pdfUrl', 'color:#e41a6a', process.env);
        const pdfUrl = '/gb-bigtree-file/download/fileDownload/install' + row.file.fileRte + '/' + row.file.name;
        this.pdfVisible = true;

        // 加载 PDF
        const loadingTask = pdfjsLib.getDocument(pdfUrl);
        const pdf = await loadingTask.promise;

        // 渲染第一页
        const page = await pdf.getPage(1);
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        this.$refs.pdfContainer.innerHTML = '';
        this.$refs.pdfContainer.appendChild(canvas);

        await page.render({
          canvasContext: context,
          viewport
        }).promise;
      } else {
        this.viewSrc = '/gb-bigtree-file/download/fileDownload/install' + row.file.fileRte + '/' + row.file.fileNm;
        this.$refs.imgView.show();
      }
      console.log('%c Line:455 🍩 row', 'color:#e41a6a', row);
      // this.pdfUrl = '/gb-bigtree-file/download/fileDownload/install' +
      //     row.file.fileRte +
      //     '/' +
      //     row.file.name
      //       this.pdfVisible = true;
    }
  },
  watch: {},
  activated() {}
};
</script>
<style scoped lang="less">
.img-tip {
  white-space: nowrap;
  position: absolute;
  left: 120px;
  font-size: 12px;
  top: 0;
}
.ellipsis {
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 显示省略号 */
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/payable/delivery-voucher-dialog.vue